import { createContext, MutableRefObject } from 'react';

interface MaritimeDirectoryPortEditorContextProps {
  maritimeDirectoryId: string;
  refresh: () => void;
  hasChanged: MutableRefObject<boolean | null>;
}

const MaritimeDirectoryPortEditorContext = createContext<MaritimeDirectoryPortEditorContextProps>({
  maritimeDirectoryId: '',
  refresh: () => {},
  hasChanged: { current: null }
});

export default MaritimeDirectoryPortEditorContext;
